/**
 * Get the display URL for a portfolio item.
 * For uploaded files, constructs the API serving endpoint URL.
 * For external links, returns the URL as-is.
 */
export default function getPortfolioUrl(item) {
  if (item.type === "file" && item.url?.startsWith("uploads/")) {
    const apiUrl = process.env.NEXT_PUBLIC_LARAVEL_API_URL || "";
    return `${apiUrl}/api/portfolio/${item.url.replace("uploads/portfolio/", "")}`;
  }
  return item.url;
}
